import axios from 'axios';
import {BASE_URL} from '../variables/base';

let ajax = axios.create({
    baseURL: BASE_URL,
    timeout: 3000,
    headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    withCredentials: true
});

export default {
    methods: {
        ajaxPost(url, data, config) {
            let json = JSON.stringify(data);
            return ajax.post(url, json, config);
        },
        importScript(url) {
            return new Promise((resolve, reject) => {
                let script = document.createElement('script');
                script.src = url;
                script.charset = 'utf-8';
                script.onload = () => {
                    resolve(script);
                };
                script.onerror = () => {
                    reject(script);
                }
                document.body.appendChild(script);
            });
        },
        preloadImage(urls, callback, query) {
            let promises = [];
            urls.forEach((url) => {
                let promise = new Promise((resolve, reject) => {
                    let image = new Image();
                    image.onload = () => {
                        if (callback) callback();
                        resolve(image);
                    };
                    image.onerror = () => reject();
                    image.src = url + (query || '');
                });
                promises.push(promise);
            });
            return Promise.all(promises);
        }
    }
};